module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAPCAYAAADQ4S5JAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADmSURBVHgBlVKxDYMwELQNBWWyQbIB2cAZIROEBkHpUehAogkTRJkgMEHIBt4Al1Ag8o7eCKygwEmvf+7v3viBEgtCiF3XdXwYBpVlWWn36fQhDEOfMfaklO6Qkn3fX/I8r42GTSc7jnMH8cPzvD1QR4hKc7pndK4p2rb1IR0gzkmSKMgKhAL4Bnvl7AQUE3hvaQg0jr3vHeI45pCvSOr6RuYIcLqEKFwUBpbABsdcMbIRS4YKtlWvNbzh4jxN0xPBzfwzNKaYfMAR7g8Dj6LoBWIFv4e/xqAn+2QBm7ekT5AQxUq9/ABKx0iLRSX/MgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/pages/administratorsOnlyEducationStaffManagement/assets/Vector.png
// module id = D2fe
// module chunks = 1